module.exports = __webpack_public_path__ + "img/160x130.753fb1a5.png";